import React from "react";
import projects from "./../static/projects_data.json";
import { useEffect } from "react";
function HomePage() {
    useEffect(() => {
        const options = {
            threshold: 0,
        };
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                entry.target.classList.toggle(
                    "project-animation-show",
                    entry.isIntersecting
                );
                if (entry.isIntersecting) observer.unobserve(entry.target);
            });
        }, options);

        const projectDivsLeft = document.getElementsByClassName(
            "project-animation-left"
        );
        const projectDivsRight = document.getElementsByClassName(
            "project-animation-right"
        );
        // console.log(projectDivs);
        //
        //         projectDivs.forEach((projectDiv) => {
        //             observer.observe(projectDiv);
        //         });
        for (let projectDiv of projectDivsLeft) {
            observer.observe(projectDiv);
        }
        for (let projectDiv of projectDivsRight) {
            observer.observe(projectDiv);
        }
    }, []);

    useEffect(() => {
        const options = {
            threshold: 0.5,
        };
        const observer = new IntersectionObserver((entries) => {
            // entries[0].target.classList.toggle(
            //     "top-down-animation-show",
            //     entries[0].isIntersecting
            // );
            // if (entries[0].isIntersecting)
            //     observer.unobserve(entries[0].target);
            entries.forEach((entry) => {
                entry.target.classList.toggle(
                    "top-down-animation-show",
                    entry.isIntersecting
                );

                if (entry.isIntersecting) observer.unobserve(entry.target);
            });
        }, options);

        const elements = document.querySelectorAll(".top-down-animation-hero");
        console.log(elements);

        for (let el of elements) {
            observer.observe(el);
        }
    }, []);

    return (
        <>
            <div className="text-white max-w-screen-lg my-0 mx-auto mt-32 px-9 flex flex-col items-center justify-center mb-16 top-down-animation-hero">
                <div className="w-96 h-96 mb-16">
                    <img
                        src="/profile-pic-current.jpg"
                        alt="Naveen's profile"
                        className="w-full h-full rounded-full object-cover"
                    />
                </div>
                <h3 className="mb-4 text-gray-300 font-medium">
                    Hi there, I am{" "}
                    <span style={{ color: "#ffe100" }}>Naveen RK</span>
                </h3>
                <h3 className="text-center w-3/4 max-w-3xl font-bold">
                    Self Taught Software Engineer | Content Creator | Freelance
                    Developer
                </h3>
            </div>
            <div
                className="my-16 text-center px-4 py-4 text-white flex items-center gap-16 justify-center h-32 top-down-animation-hero"
                style={{ backgroundColor: "rgba(40,40,40,255)" }}
            >
                <div>
                    <span className="span"></span>
                    <span className="span"></span>
                </div>
                <h3 className="font-medium">Checkout my projects below</h3>
                <div>
                    <span className="span"></span>
                    <span className="span"></span>
                </div>
            </div>

            <div className="max-w-screen-2xl my-0 mx-auto px-9">
                {projects.length > 0 &&
                    projects.map((project, idx) => {
                        return (
                            <div
                                className={`flex 
                                xl:flex-col
                                min-h-96 gap-16 w-full mb-32 py-16 px-16 rounded-md 
                                max-xl:flex-col project-animation-${
                                    idx % 2 === 0 ? "left" : "right"
                                }`}
                                style={{
                                    backgroundColor: "rgba(40,40,40,255)",
                                }}
                                key={Number(project.id)}
                                id={`div-${project.id}`}
                            >
                                <div className="h-full w-full">
                                    <img
                                        src={project.featured_image}
                                        alt={project.title}
                                    />
                                </div>

                                <div className="text-gray-300 w-4/5">
                                    <h2
                                        className="mb-4 font-bold"
                                        style={{ color: "#ffe100" }}
                                    >
                                        {project.title}
                                    </h2>
                                    <p
                                        style={{
                                            whiteSpace: "pre-line",
                                            fontSize: "1.6rem",
                                            fontWeight: "500",
                                        }}
                                    >
                                        {project.description}
                                    </p>

                                    <div>
                                        <p
                                            style={{
                                                fontSize: "1.8rem",
                                                fontWeight: "bold",
                                                marginTop: "2rem",
                                            }}
                                        >
                                            Github Links
                                        </p>
                                        {Object.entries(
                                            project.github_links
                                        ).map((link, index) => {
                                            return (
                                                <a
                                                    href={link[1]}
                                                    className="text-2xl block mt-4 underline font-medium"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    key={index}
                                                >
                                                    {link[1]}
                                                </a>
                                            );
                                        })}
                                        <p
                                            style={{
                                                fontSize: "1.8rem",
                                                fontWeight: "bold",
                                                marginTop: "2rem",
                                            }}
                                        >
                                            Stack
                                        </p>
                                        <div className="flex gap-4 items-center justify-start">
                                            {project.stackUsed.map(
                                                (stack, idx, arr) => {
                                                    if (idx < 3)
                                                        return (
                                                            <span
                                                                className="text-lg mt-4 font-semibold bg-white text-black px-4 py-2 rounded-lg"
                                                                key={idx}
                                                            >
                                                                {stack}
                                                            </span>
                                                        );
                                                    return <></>;
                                                }
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </div>
        </>
    );
}

export default HomePage;
